import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from "@/utils/localStorageHelper";
import { localStorageKey } from "@/enums/localStorageKey";
import { ExpenseFilter, Filter, FilterState } from "@/types/filter";
const filter = getLocalStorageItem(localStorageKey.FILTER) as Filter;
const filterInitial: Filter = {
  date: "",
  startDate: "",
  endDate: "",
  branchId: [],
  categoryId: [],
  itemsId: [],
  paymentMethod: [],
  search: "",
  reimbursed: "",
};

const initialState: FilterState = {
  filter: filter ? filter : filterInitial,
  filteredExpenses: [],
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<Filter>) => {
      state.filter = {
        ...action.payload,
      };

      setLocalStorageItem(localStorageKey.FILTER, action.payload);
    },
    setFilteredExpenses: (state, action: PayloadAction<ExpenseFilter[]>) => {
      state.filteredExpenses = action.payload;
    },

    removeFilter: (state: FilterState) => {
      state.filter = filterInitial;
      removeLocalStorageItem(localStorageKey.FILTER);
    },
  },
});

export const { setFilter, removeFilter, setFilteredExpenses } =
  filterSlice.actions;

export default filterSlice.reducer;
